import {CalculatedCvComponent } from './CalculatedCv'
import { MissingCompetenceComponent } from './MissingCompetence'

export const CalculatedCvRoutes = [
    {
        path: '/calculatedcv',
        element: <CalculatedCvComponent />,
        role: 'Pocahontas_CalculateCv'
    },
    {
        path: '/missingcompetence',
        element: <MissingCompetenceComponent />,
        role: 'Pocahontas_MissingCompetence'
    }
]